import { CountryCode } from 'libphonenumber-js';
import { type ReactNode } from 'react';
import ReactCountryFlag from 'react-country-flag';
type CountryOption = {
  code: CountryCode;
  name: string;
};
export const countryList: CountryOption[] = [{
  code: 'GB',
  name: 'United Kingdom'
}, {
  code: 'AL',
  name: 'Albania'
}, {
  code: 'AD',
  name: 'Andorra'
}, {
  code: 'AM',
  name: 'Armenia'
}, {
  code: 'AT',
  name: 'Austria'
}, {
  code: 'AZ',
  name: 'Azerbaijan'
}, {
  code: 'BY',
  name: 'Belarus'
}, {
  code: 'BE',
  name: 'Belgium'
}, {
  code: 'BA',
  name: 'Bosnia and Herzegovina'
}, {
  code: 'BG',
  name: 'Bulgaria'
}, {
  code: 'HR',
  name: 'Croatia'
}, {
  code: 'CY',
  name: 'Cyprus'
}, {
  code: 'CZ',
  name: 'Czech Republic'
}, {
  code: 'DK',
  name: 'Denmark'
}, {
  code: 'EE',
  name: 'Estonia'
}, {
  code: 'FI',
  name: 'Finland'
}, {
  code: 'FR',
  name: 'France'
}, {
  code: 'DE',
  name: 'Germany'
}, {
  code: 'GR',
  name: 'Greece'
}, {
  code: 'HU',
  name: 'Hungary'
}, {
  code: 'IS',
  name: 'Iceland'
}, {
  code: 'IE',
  name: 'Ireland'
}, {
  code: 'IT',
  name: 'Italy'
}, {
  code: 'LV',
  name: 'Latvia'
}, {
  code: 'LI',
  name: 'Liechtenstein'
}, {
  code: 'LT',
  name: 'Lithuania'
}, {
  code: 'LU',
  name: 'Luxembourg'
}, {
  code: 'MT',
  name: 'Malta'
}, {
  code: 'MD',
  name: 'Moldova'
}, {
  code: 'MC',
  name: 'Monaco'
}, {
  code: 'ME',
  name: 'Montenegro'
}, {
  code: 'NL',
  name: 'Netherlands'
}, {
  code: 'MK',
  name: 'North Macedonia'
}, {
  code: 'NO',
  name: 'Norway'
}, {
  code: 'PL',
  name: 'Poland'
}, {
  code: 'PT',
  name: 'Portugal'
}, {
  code: 'RO',
  name: 'Romania'
}, {
  code: 'SM',
  name: 'San Marino'
}, {
  code: 'RS',
  name: 'Serbia'
}, {
  code: 'SK',
  name: 'Slovakia'
}, {
  code: 'SI',
  name: 'Slovenia'
}, {
  code: 'ES',
  name: 'Spain'
}, {
  code: 'SE',
  name: 'Sweden'
}, {
  code: 'CH',
  name: 'Switzerland'
}, {
  code: 'TR',
  name: 'Turkey'
}, {
  code: 'UA',
  name: 'Ukraine'
}];
const generateCountryLabelWithFlag = (countryCode: string, countryName: string) => <div className={'flex items-center'} data-sentry-component="generateCountryLabelWithFlag" data-sentry-source-file="country-list.tsx">
    <ReactCountryFlag aria-label={`Flag of ${countryName}`} countryCode={countryCode} title={countryName} data-sentry-element="ReactCountryFlag" data-sentry-source-file="country-list.tsx" />
    <span className={'mb-0 ml-2'}>{countryName}</span>
  </div>;
export interface ICountryListWithFlags {
  code: CountryCode;
  label: ReactNode;
  name: string;
}
export const countryListWithFlags = countryList.map((option): ICountryListWithFlags => ({
  ...option,
  label: generateCountryLabelWithFlag(option.code, option.name)
}));
export function convertToIso(country?: string) {
  if (!country) return 'GB';
  return countryList.find(c => c.name.toLowerCase() === country.toLowerCase())?.code ?? 'GB';
}